import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=35d4576b&scoped=true"
import script from "./Affiliates.vue?vue&type=script&setup=true&lang=ts"
export * from "./Affiliates.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=35d4576b&prod&scoped=true&lang=css"
import style1 from "./Affiliates.vue?vue&type=style&index=1&id=35d4576b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4576b",
  null
  
)

export default component.exports